import { render, staticRenderFns } from "./FormSuccessPage.vue?vue&type=template&id=b53810fa"
import script from "./FormSuccessPage.vue?vue&type=script&lang=js"
export * from "./FormSuccessPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports